// Copyright (c) 2022, Compiler Explorer Authors
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//     * Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

import {localStorage} from './local.js';

const CURRENT_SLIDE_KEY = 'presentationCurrentSlide';

export class Presentation {
    public currentSlide = Number.parseInt(localStorage.get(CURRENT_SLIDE_KEY, '0'));
    public originalLocation = window.location.href;

    public constructor(public maxSlides: number) {}

    public first() {
        this.currentSlide = 0;
        localStorage.set(CURRENT_SLIDE_KEY, this.currentSlide.toString(10));
        this.show();
    }

    public next() {
        if (this.currentSlide < this.maxSlides - 1) {
            this.currentSlide++;
            localStorage.set(CURRENT_SLIDE_KEY, this.currentSlide.toString(10));
            this.show();
        }
    }

    public previous() {
        if (this.currentSlide > 0) {
            this.currentSlide--;
            localStorage.set(CURRENT_SLIDE_KEY, this.currentSlide.toString(10));
            this.show();
        }
    }

    public show() {
        window.hasUIBeenReset = true;
        if (window.location.href === this.originalLocation) {
            window.location.reload();
        } else {
            window.location.href = this.originalLocation;
        }
    }
}
